module.exports = __webpack_public_path__ + "static/sharptree_horizontal_logo-9e3e56b18bfd2cbd9b782827baa0471e.png";